import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[campusClickPreventDefault],[clickPreventDefault],[click-prevent-default]',
})
export class ClickPreventDefaultDirective {
  @HostListener('click', ['$event'])
  public onClick(event: MouseEvent): void {
    event.preventDefault();
  }
}
